import { ThemeModule } from "../types"

export type ThemeLoader = () => Promise<ThemeModule>
/**
 * webpackChunkName tells webpack which chunk this is.
 * biggest problem, webpack bundled themes into core, solved by adding a regex which excluded catalogs/ folder
 * shared: {
 *     test: /[\\/]core[\\/](?!theme[\\/]src[\\/]catalogs[\\/][\w-_]*[\\/])/,
 *     name: "shared",
 *     chunks: "all",
 *     priority: 2,
 * },
 */

const themes: Record<string, ThemeLoader> = {
    aagonline: () => import(/* webpackChunkName: "catalogs/aagonline" */ "./aagonline"),
    admaroc: () => import(/* webpackChunkName: "catalogs/admaroc" */ "./admaroc"),
    aldoc: () => import(/* webpackChunkName: "catalogs/aldoc" */ "./aldoc"),
    birner: () => import(/* webpackChunkName: "catalogs/birner" */ "./birner"),
    bm: () => import(/* webpackChunkName: "catalogs/bm" */ "./bm"),
    bmc: () => import(/* webpackChunkName: "catalogs/bmc" */ "./bmc"),
    car: () => import(/* webpackChunkName: "catalogs/car" */ "./car"),
    ciak: () => import(/* webpackChunkName: "catalogs/ciak" */ "./ciak"),
    coparts: () => import(/* webpackChunkName: "catalogs/coparts" */ "./coparts"),
    default: () => import(/* webpackChunkName: "catalogs/default" */ "./default"),
    elekat: () => import(/* webpackChunkName: "catalogs/elekat" */ "./elekat"),
    esa: () => import(/* webpackChunkName: "catalogs/esa" */ "./esa"),
    gmt: () => import(/* webpackChunkName: "catalogs/gmt" */ "./gmt"),
    goehrum: () => import(/* webpackChunkName: "catalogs/goehrum" */ "./goehrum"),
    heil: () => import(/* webpackChunkName: "catalogs/heil" */ "./heil"),
    hostettler: () => import(/* webpackChunkName: "catalogs/hostettler" */ "./hostettler"),
    iaponiki: () => import(/* webpackChunkName: "catalogs/iaponiki" */ "./iaponiki"),
    jurprom: () => import(/* webpackChunkName: "catalogs/jurprom" */ "./jurprom"),
    kastner: () => import(/* webpackChunkName: "catalogs/kastner" */ "./kastner"),
    lkq: () => import(/* webpackChunkName: "catalogs/lkq" */ "./lkq"),
    lkqbe: () => import(/* webpackChunkName: "catalogs/lkqbe" */ "./lkqbe"),
    maclon: () => import(/* webpackChunkName: "catalogs/maclon" */ "./maclon"),
    matthies: () => import(/* webpackChunkName: "catalogs/matthies" */ "./matthies"),
    matthies2: () => import(/* webpackChunkName: "catalogs/matthies2" */ "./matthies2"),
    neimcke: () => import(/* webpackChunkName: "catalogs/neimcke" */ "./neimcke"),
    promofficina: () => import(/* webpackChunkName: "catalogs/promofficina" */ "./promofficina"),
    rete1one: () => import(/* webpackChunkName: "catalogs/rete1one" */ "./rete1one"),
    "schmettau-fuchs": () => import(/* webpackChunkName: "catalogs/schmettau" */ "./schmettau-fuchs"),
    "tech-co": () => import(/* webpackChunkName: "catalogs/tech-co" */ "./tech-co"),
    texkat: () => import(/* webpackChunkName: "catalogs/texkat" */ "./texkat"),
    tokic: () => import(/* webpackChunkName: "catalogs/tokic" */ "./tokic"),
    "tokic-tsm": () => import(/* webpackChunkName: "catalogs/tokic-tsm" */ "./tokic-tsm"),
    wm: () => import(/* webpackChunkName: "catalogs/wm" */ "./wm"),
}

export function loadTheme(themeName: string) {
    const key = themeName.toLowerCase()

    if (key in themes) {
        return themes[key]()
    }

    return undefined
}
